import React, { useEffect } from 'react'
import DashboardPage from '../../components/DashboardPage/DashboardPage'
import { Button, Card, Col, Row } from 'react-bootstrap'
import { transferState, getTransferDetails, listTransferFiles, resetTransferDetails, resetTransferFiles } from '../../features/transfers/transferSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/hooks';
import { useParams } from 'react-router-dom';
import { countdown, formatDate, humanizeBytes } from '../../shared/helpers/helpers';
import BackButton from '../../components/BackButton/BackButton';
import SmashSpinner from '../../components/SmashSpinner/SmashSpinner';
import ConfirmDeleteTransferModal from '../../features/transfers/components/ConfirmDeleteTransferModal';
import TransferStatus from '../../features/transfers/components/TransferStatus';
import ListReceivers from '../../features/transfers/components/ListReceivers';
import ListTransferFiles from '../../features/transfers/components/ListTransferFiles';
import Paginator from '../../components/Paginator/Paginator';
import { useTransferFiles } from '../../features/transfers/hooks/useTransferFiles';

const TransferDetails = () => {
  const [isLoading, files, previous, next] = useTransferFiles();
  let { id } = useParams();
  const { transferDetails } = useAppSelector(transferState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetTransferDetails());
  }, []);

  useEffect(() => {    
    if (id) {
        dispatch(getTransferDetails({ transferId: id }));
        dispatch(listTransferFiles({ transferId: id }));
    }
  }, []);

  const handlePrevious = ({ start, hadNext}: { start: string, hadNext: boolean }) => {
    if(transferDetails.transfer) {
      if(start === 'firstPage') {
          dispatch(resetTransferFiles());
      } else {
          dispatch(listTransferFiles({ transferId:  transferDetails.transfer.id, start, hadNext}));
      }
    }
  };

  const handleNext = ({ start, hasPrevious }: { start?: string, hasPrevious: boolean }) => {
      if(transferDetails.transfer)
        dispatch(listTransferFiles({ transferId: transferDetails.transfer.id, start, hasPrevious }));
  };

  return (
    <>
      <DashboardPage heading={`Transfers > ${transferDetails?.transfer?.id}`}>
        <BackButton />
        <Card className="my-3">
          <Card.Header as="h5">
              <Row>
                <Col className="hstack gap-3 d-flex align-items-center">
                  Transfer details
                </Col>
                {!transferDetails.isLoading && transferDetails.transfer && transferDetails.transfer.status === 'Uploaded' && <Col className="hstack gap-3 d-flex justify-content-end align-items-center">  
                  <ConfirmDeleteTransferModal item={transferDetails.transfer}>
                    <Button>Delete Transfer</Button>
                  </ConfirmDeleteTransferModal>
                </Col>}
              </Row>
          </Card.Header>
          <Card.Body>
            {transferDetails.isLoading && <SmashSpinner />}
            {!transferDetails.isLoading && transferDetails.transfer && <>
              <p><strong>Creation date: </strong>{formatDate(transferDetails.transfer.created as string)}</p>
              {transferDetails.transfer?.delivery?.type && <p><strong>Type: </strong>{transferDetails.transfer.delivery?.type}</p>}
              <p><strong>Files number: </strong>{transferDetails.transfer.filesNumber}</p>
              <p><strong>Size: </strong>{humanizeBytes(transferDetails.transfer.size)}</p>
              <p><strong>Url: </strong><a className="link-primary" rel="noreferrer" href={transferDetails.transfer.transferUrl} target="_blank">{transferDetails.transfer.transferUrl}</a></p>
              <p><strong>Status: </strong><TransferStatus status={transferDetails.transfer.status}/></p>    
              {transferDetails.transfer.status === 'Uploaded' && <p><strong>Availability duration: </strong>Will expire {countdown(transferDetails.transfer.availabilityEndDate)}</p> }
              {transferDetails.transfer.status === 'Expired' && <p><strong>Availability duration: </strong>Expired {countdown(transferDetails.transfer.availabilityEndDate)}</p> }
              {transferDetails.transfer.status === 'Deleted' && <p><strong>Availability duration: </strong>Deleted {countdown(transferDetails.transfer.deleted as string)}</p> }
              {transferDetails.transfer.delivery?.sender?.email && <p><strong>Sender: </strong>{transferDetails.transfer.delivery?.sender?.email}</p>}
            </>
            }
          </Card.Body>
        </Card>
        <Card className="my-3">
          <Card.Header as="h5">
                <Row>
                  <Col className="hstack gap-3 d-flex align-items-center">
                    Transfer files
                  </Col>
                  <Col className="hstack gap-3 d-flex justify-content-end align-items-center">
                      <Paginator onNext={handleNext} onPrevious={handlePrevious} previous={previous} next={next} />                  
                  </Col>
                </Row>
            </Card.Header>
            <Card.Body>
            <ListTransferFiles />
            </Card.Body>
        </Card>
        {transferDetails.transfer?.delivery?.receivers && <Card className="my-3">
          <Card.Header as="h5">
              <Row>
                <Col className="hstack gap-3 d-flex align-items-center">
                  Transfer receivers
                </Col>                
              </Row>
          </Card.Header>
          <Card.Body>
            {transferDetails.isLoading && <SmashSpinner />}
            {!transferDetails.isLoading && <ListReceivers receivers={transferDetails.transfer.delivery.receivers}/>}
          </Card.Body>
        </Card>}
      </DashboardPage>
    </>
  )
  
}

export default TransferDetails